import {apiClient, queryClient} from '@common/http/query-client';
import {BillingSource} from '@common/billing/billing-page/use-billing-user';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {useQuery} from '@tanstack/react-query';

export interface TenantInfo {
  id: number;
  name: string;
  domain?: string | null;
  subdomain?: string | null;
}

export function useTenantBilling(): BillingSource {
  const bootstrapTenant = getBootstrapData()?.current_tenant as TenantInfo | undefined;

  const tenantQuery = useQuery({
    queryKey: ['tenant', 'current'],
    queryFn: () => {
  
      return apiClient.get('tenant/current').then(response => {
       
        return response.data.tenant as TenantInfo;
      });
    },
    staleTime: 5 * 60 * 1000,
    enabled: !bootstrapTenant,
  });

  const tenant = bootstrapTenant || tenantQuery.data;
  const tenantId = tenant?.id;


  const tenantSubQuery = useQuery({
    queryKey: ['tenant', 'subscription', tenantId],
    queryFn: () => {
      
      return apiClient
        .get('tenant/subscription')
        .then(response => {
         
          return response.data.subscription;
        })
        .catch(err => {
          console.error('[useTenantBilling] tenant/subscription ERROR:', err);
          throw err;
        });
    },
    enabled: !!tenantId,
    staleTime: 0, // Always consider stale, will refetch on mount and user interactions
    gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes for background refetching
  });



  return {
    subscription: tenantSubQuery.data,
    isLoading: tenantQuery.isLoading || tenantSubQuery.isLoading,
    tenant,
    tenantId,
    source: 'tenant',
    invalidate: invalidateTenantBillingQuery,
  };
}

export function invalidateTenantBillingQuery() {
  queryClient.invalidateQueries({queryKey: ['tenant']});
  queryClient.invalidateQueries({queryKey: ['tenant', 'subscription']});
}
